export default {"src":"/_next/static/media/eye-fill.1185e7ba.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};